import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { combineValidators, isRequired } from 'revalidate';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Row,
} from 'shards-react';

import { ReactComponent as Logo } from '../../../assets/img/homepage/contact.svg';
import TextInput from '../../common/form/TextInput';
import { registerUser } from '../Auth/authActions';
import SocialLogin from './SocialLogin/SocialLogin';
import { socialLogin } from './authActions';
import LoadingOverlay from 'react-loading-overlay';
import Navbar from '../../layout/Navbar/Navbar';
import { fullName, email } from '../../common/util/validation';

const mapState = (state) => ({
  loading: state.async.loading,
});

const actions = {
  registerUser,
  socialLogin,
};

const validate = combineValidators({
  displayName: isRequired('display name'),
  email: isRequired('email'),
  password: isRequired('password'),
});

const Register = ({
  handleSubmit,
  registerUser,
  history,
  error,
  invalid,
  submitting,
  socialLogin,
  loading,
}) => {
  return (
    <div>
      <Navbar />
      <Container className='login-form py-3' fluid>
        <Row form>
          <Col className='text-center col' sm='12' lg='6'>
            <div>
              <h3 className=''>Welcome</h3>
              <h4>
                Are you new here? Please help us to get to know you better?
              </h4>
              <Logo className='svg' />
            </div>
          </Col>
          <Col sm='12' lg='6' className='p-3'>
            <LoadingOverlay active={loading} spinner>
              <Card small>
                <CardHeader className='bg-secondary text-white text-center'>
                  <h4 className='text-white'>Registration Form</h4>
                </CardHeader>
                <CardBody className='text-center'>
                  <Form onSubmit={handleSubmit(registerUser)}>
                    <FormGroup className='text-left'>
                      <label htmlFor='displayName'>Display Name</label>
                      <Field
                        name='displayName'
                        type='text'
                        placeholder='Enter your short name'
                        component={TextInput}
                        validate={fullName}
                      />
                    </FormGroup>
                    <FormGroup className='text-left'>
                      <label htmlFor='email'>Email</label>
                      <Field
                        name='email'
                        type='email'
                        placeholder='Enter Email'
                        component={TextInput}
                        validate={email}
                      />
                    </FormGroup>
                    <FormGroup className='text-left'>
                      <label htmlFor='password'>Password</label>
                      <Field
                        name='password'
                        component={TextInput}
                        type='password'
                        placeholder='Enter Password'
                      />
                    </FormGroup>
                    <Button
                      theme='success'
                      pill
                      type='submit'
                      className='text-center'
                    >
                      Register
                    </Button>
                    <div className='text-center mx-auto'>
                      {error && <label className='error-label'>{error}</label>}
                    </div>

                    {/* <SocialLogin socialLogin={socialLogin} /> */}
                  </Form>
                </CardBody>

                <CardFooter className='text-center'>
                <div className='divider'>Or</div>
                  <Button
                    theme='primary'
                    pill
                    onClick={() => history.push('/login')}
                  >
                    Log In
                  </Button>
                </CardFooter>
              </Card>
            </LoadingOverlay>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default withRouter(
  connect(
    mapState,
    actions
  )(reduxForm({ form: 'RegisterForm', validate })(Register))
);
